/** Пустая страница проекта до выбора эпика */
const ProjectOverviewPage = () => (
    <div className="epic-select-empty" aria-live="polite">
        <p className="epic-select-empty__label">Выберите эпик</p>
    </div>
);

export default ProjectOverviewPage;
